module.exports = __webpack_public_path__ + "img/receipt.dded4285.png";